export const tabsTypes = {
  all: 'All',
  incoming: 'Incoming',
  outgoing: 'Outgoing'
  //   revenue: 'Expected Revenue'
};
